import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Pasarela } from '../../Service/pasarela.service'
import { PrimeraEtapa, PrimeraEtapaMedioPago } from '../../Interface/PrimeraEtapa';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { MedioPago } from 'src/app/Interface/MedioPago';
import { firstValueFrom } from 'rxjs';
import { DomManagerService } from '../../Service/dom-manager.service';
@Component({
  selector: 'app-pasarela-pago',
  templateUrl: './pasarela-pago.component.html',
  styleUrls: ['./pasarela-pago.component.scss']
})

export class PasarelaPagoComponent implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute, 
    public pasarelaservice: Pasarela, 
    private location: Location,
    private domManager: DomManagerService
  ) { }
  medioPagoSeleccionado: string = ''
  seleccionQA: boolean = false
  isQA: boolean = false
  active: boolean = false
  active2: boolean = false
  active3: boolean = false
  active4: boolean = false
  inactive: boolean = false
  inactive2: boolean = false
  inactive3: boolean = false
  inactive4: boolean = false
  MWebpay: boolean = false;
  MKhipu: boolean = false;
  MMercado: boolean = false;
  mostrarModalTimeout: boolean = false;
  url:string = ""
  pathClock = "../../../assets/img/clock2.png"
  OWebpay = [{ value: '1', label: 'WEBPAY (Tarjetas de Débito o Crédito)', checked: false }]
  OKhipu = [{ value: '1', label: '	KHIPU (Transferencia Electrónica)', checked: false }]
  OMercado = [{ value: '1', label: '	MERCADO PAGO', checked: false }]
  segundos: number = 120
  private countdownInterval?: NodeJS.Timeout;
  private startTime?: number;
  private totalSeconds = 120;
  color = "#00ADEF"
  colorb = "primary"
  size = "60px"
  cargando = false;
  punto = "."
  metodo = "";
  veralerta = false;
  type: "info" | "success" | "warning" | "error" = "error";
  message = "esto es una prueba";
  closeable = false
  MForpay: boolean = false;
  OForpay = [{ value: '1', label: 'FORPAY', checked: false }];

  // Datos del cliente
  nombreCliente: string = '';
  rut: string = '';
  email: string = '';
  tipoCompra: string = 'Compra web';
  tipoDocumento: string = 'Factura';
  origen: string = '';

  // Datos de pago
  subtotal: number = 0;
  intereses: number = 0;
  total: number = 0;

  private readonly MEDIOS_PAGO_CONFIG: { [key: string]: MedioPago } = {
    'Webpay': {
      id: 'webpay',
      nombre: 'Webpay (Tarjetas de Débito o Crédito)',
      imagen: 'assets/img/webpay.png'
    },
    'Khipu': {
      id: 'khipu',
      nombre: 'KHIPU (Transferencia electrónica)',
      imagen: 'assets/img/khipu.png'
    },
    'MercadoPago': {
      id: 'mercadopago',
      nombre: 'MERCADO PAGO',
      imagen: 'assets/img/mercadopago.png'
    },
    'Forpay': {
      id: 'forpay',
      nombre: 'FORPAY',
      imagen: 'assets/img/forpay.png'
    }
  };

  mediosPago: MedioPago[] = [];


  ngOnInit(): void {
    this.isQA = environment.environment === 'QA' ? true : false;
    let token = this.route.snapshot.paramMap.get('token') ?? '';
    this.startCountdown();
    setInterval(() => { this.puntos() }, 350)
    this.pasarelaservice.login().subscribe((data) => {
      this.pasarelaservice.primeraetapa(token, data.access_token).subscribe(
        (data) => {
          if ('mensaje' in data && 'datos' in data && data.cuenta.datos?.['UrlRetorno']) {
            alert(data.cuenta.mensaje);
            window.location.href = data.cuenta.datos?.['UrlRetorno'];
          }
          if (data) {
            this.url = data.datosAdicionales.UrlRetorno;
            this.nombreCliente = data.cuenta.nombre;
            this.rut = data.cuenta.rut;
            this.email = data.cuenta.email;
            this.origen = data.cuenta.origen;
            this.subtotal = data.cuenta.totalValor;
            this.intereses = data.cuenta.totalInteres;
            this.total = data.cuenta.totalValor + data.cuenta.totalInteres;
            data.cuenta.medios.forEach((medio: PrimeraEtapaMedioPago) => {
              this.metodo += medio.disponible + ";"
              this.mediosPago.push(this.MEDIOS_PAGO_CONFIG[medio.disponible]);
            });
            // Agregar Forpay si está disponible
            if (this.metodo.includes('Forpay')) {
              this.OForpay[0].checked = false;
            }
            
            // Actualizar header y footer si están presentes en la respuesta
            this.updateHeaderAndFooter(data);
            
            if(data.cuenta.medios.length === 1){
              switch(data.cuenta.medios[0].disponible){
                case 'Webpay':
                  this.MWebpay = true;
                  this.medioPagoSeleccionado = 'webpay';
                  break;
                case 'Khipu':
                  this.MKhipu = true;
                  this.medioPagoSeleccionado = 'khipu';
                  break;
                case 'MercadoPago':
                  this.MMercado = true;
                  this.medioPagoSeleccionado = 'mercadopago';
                  break;
                case 'Forpay':
                  this.MForpay = true;
                  this.medioPagoSeleccionado = 'forpay';
                  break;
              }
              // Ejecutar pago automáticamente después de un pequeño delay
              setTimeout(() => {
                this.pagar();
              }, 500);
            }
          } else {
            console.log("La respuesta no contiene la estructura esperada.");
          }
        },
        (error) => {
          console.error(error);
        }
      );
    })
  }
  cambiarambiete() {
    this.seleccionQA = !this.seleccionQA
  }
  private startCountdown(): void {
    this.startTime = Date.now();
    this.segundos = this.totalSeconds;
    
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 100); // Verificar cada 100ms para mayor precisión
  }

  private updateCountdown(): void {
    if (!this.startTime) return;
    
    // Calcular tiempo transcurrido basado en tiempo real
    const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
    this.segundos = Math.max(0, this.totalSeconds - elapsed);
    
    if (this.segundos <= 0) {
      this.clearCountdown();
      this.mostrarModalTimeout = true;
      // Mostrar el modal usando Bootstrap
      setTimeout(() => {
        this.mostrarModal();
      }, 100);
    }
  }

  private clearCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = undefined;
    }
  }

  ngOnDestroy(): void {
    this.clearCountdown();
  }

  private mostrarModal(): void {
    const modalElement = document.getElementById('timeoutModal');
    if (modalElement) {
      // Verificar si Bootstrap está disponible
      if (typeof (window as any).bootstrap !== 'undefined' && (window as any).bootstrap.Modal) {
        const modal = new (window as any).bootstrap.Modal(modalElement);
        modal.show();
      } else {
        // Fallback: mostrar modal sin Bootstrap (solo CSS)
        console.warn('Bootstrap no está disponible, usando fallback CSS');
        modalElement.classList.add('show');
        modalElement.style.display = 'block';
        document.body.classList.add('modal-open');
      }
    }
  }


  cerrarModalYRedirigir(): void {
    // Cerrar el modal
    const modalElement = document.getElementById('timeoutModal');
    if (modalElement) {
      // Verificar si Bootstrap está disponible
      if (typeof (window as any).bootstrap !== 'undefined' && (window as any).bootstrap.Modal) {
        const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
        if (modal) {
          modal.hide();
        }
      } else {
        // Fallback: ocultar modal sin Bootstrap
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        document.body.classList.remove('modal-open');
      }
    }
    
    // Ocultar el modal y redirigir
    this.mostrarModalTimeout = false;
    
    // Redirigir después de un pequeño delay para que el modal se cierre suavemente
    setTimeout(() => {
      if (this.url) {
        window.location.href = this.url + "2&error=408&descerror=El tiempo para realizar el pago ha expirado.";
      } else {
        this.location.back();
      }
    }, 300);
  }
  qa(destino: string) {
    let token = this.route.snapshot.paramMap.get('token')
    let url = 'https://mipagoqa' + destino + '.kaufmann.cl/pasarelapago/' + token
    window.location.href = url
  }
  puntos() {
    this.punto = this.punto.length > 3 ? "." : this.punto + ".";

  }
  pagar(){
    console.log("mediosPago");
    console.log(this.mediosPago);
    console.log("obtenerMedioPagoSeleccionado");
    if (!this.medioPagoSeleccionado) {
      this.mostrarError("Debe seleccionar un método de pago");
      return;
    }

    this.cargando = true;
    const token = this.route.snapshot.paramMap.get('token');
    
    if (!token) {
      this.mostrarError("Token no encontrado");
      this.cargando = false;
      return;
    }
    this.pasarelaservice.login().subscribe({
      next: (loginResponse) => {
        switch(this.medioPagoSeleccionado) {
          case 'webpay':
            this.procesarWebPay(token, loginResponse.access_token);
            break;
          case 'khipu':
            this.procesarKhipu(token, loginResponse.access_token);
            break;
          case 'mercadopago':
            this.procesarMercadoPago(token, loginResponse.access_token);
            break;
          case 'forpay':
            this.procesarForpay(token, loginResponse.access_token);
            break;
          default:
            this.mostrarError("Medio de pago no válido");
            this.cargando = false;
        }
      },
      error: (error) => {
        console.error('Error en login:', error);
        this.mostrarError("Error al iniciar el proceso de pago");
        this.cargando = false;
      }
    });
  }

  procesarWebPay(token: string, accessToken: string): void {
    this.pasarelaservice.pagarWebPay(token, accessToken).subscribe({
      next: (data) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = data.url;
        
        const tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = 'token_ws';
        tokenInput.value = data.token;
        
        form.appendChild(tokenInput);
        document.body.appendChild(form);
        form.submit();
      },
      error: (error) => {
        console.error('Error en WebPay:', error);
        this.mostrarError("Error al procesar el pago con WebPay");
        this.cargando = false;
      }
    });
  }

  procesarKhipu(token: string, accessToken: string): void {
    this.pasarelaservice.pagarKhipu(token, accessToken).subscribe({
      next: (data) => {
        window.location.href = data.url;
      },
      error: (error) => {
        console.error('Error en Khipu:', error);
        this.mostrarError("Error al procesar el pago con Khipu");
        this.cargando = false;
      }
    });
  }

  procesarMercadoPago(token: string, accessToken: string): void {
    this.pasarelaservice.pagarMercado(token, accessToken).subscribe({
      next: (data) => {
        window.location.href = data.url;
      },
      error: (error) => {
        console.error('Error en MercadoPago:', error);
        this.mostrarError("Error al procesar el pago con MercadoPago");
        this.cargando = false;
      }
    });
  }

  procesarForpay(token: string, accessToken: string): void {
    this.pasarelaservice.pagarForpay(token, accessToken).subscribe({
      next: (data) => {
        console.log(data);
        this.cargando = false;
      },
      error: (error) => {
        console.error('Error en Forpay:', error);
        this.mostrarError("Error al procesar el pago con Forpay");
        this.cargando = false;
      }
    });
  }

 

  private mostrarError(mensaje: string): void {
    this.message = mensaje;
    this.veralerta = true;
    this.type = "error";
  }
  cambioW(event: any) {
    this.MWebpay = event.target.checked
    this.OWebpay[0].checked = true;

    this.active2 = false
    if (this.MWebpay) {
      this.veralerta = false
      this.MKhipu = false
      this.OKhipu[0].checked = false;
      this.MMercado = false
      this.OMercado[0].checked = false;
      this.MForpay = false;
      this.OForpay[0].checked = false;
    }
    this.active = this.MWebpay
    if (this.active) {
      this.inactive2 = true
      this.inactive3 = true
      this.inactive = false
    }
    else {
      this.inactive2 = false
      this.inactive3 = false
    }
  }
  cambioK(event: any) {
    this.MKhipu = event.target.checked
    this.OKhipu[0].checked = true;
    this.active = false
    if (this.MKhipu) {
      this.veralerta = false
      this.MWebpay = false
      this.OWebpay[0].checked = false;
      this.MMercado = false
      this.OMercado[0].checked = false;
      this.MForpay = false;
      this.OForpay[0].checked = false;
    }
    this.active2 = this.MKhipu
    if (this.active2) {
      this.inactive = true
      this.inactive3 = true
      this.inactive2 = false
    }
    else {
      this.inactive = false
      this.inactive3 = false
    }
  }
  cambioM(event: any) {
    this.MMercado = event.target.checked
    this.OMercado[0].checked = true;
    if (this.MMercado) {
      this.veralerta = false
      this.MKhipu = false
      this.OKhipu[0].checked = false;
      this.MWebpay = false
      this.OWebpay[0].checked = false;
      this.MForpay = false;
      this.OForpay[0].checked = false;
    }
    this.active3 = this.MMercado
    if (this.active3) {
      this.inactive = true
      this.inactive2 = true
      this.inactive3 = false
    }
    else {
      this.inactive = false
      this.inactive2 = false
    }
  }
  cambioF(event: any) {
    this.MForpay = event.target.checked;
    this.OForpay[0].checked = true;
    if (this.MForpay) {
      this.veralerta = false;
      this.MWebpay = false;
      this.OWebpay[0].checked = false;
      this.MKhipu = false;
      this.OKhipu[0].checked = false;
      this.MMercado = false;
      this.OMercado[0].checked = false;
    }
    this.active4 = this.MForpay;
    if (this.active4) {
      this.inactive = true;
      this.inactive2 = true;
      this.inactive3 = true;
      this.inactive4 = false;
    } else {
      this.inactive = false;
      this.inactive2 = false;
      this.inactive3 = false;
    }
  }

  /**
   * Actualiza el header y footer del documento si están presentes en los datos
   * @param data Datos de la respuesta del servicio
   */
  private updateHeaderAndFooter(data: PrimeraEtapa): void {
    try {
      // Verificar si hay datos de header y footer
      if (data.header || data.footer) {
        console.log('Actualizando header y footer dinámicamente');
        
        // Usar el servicio para actualizar el DOM
        this.domManager.updateHeaderAndFooter(data.header, data.footer);
      } else {
        console.log('No se encontraron datos de header o footer en la respuesta');
      }
    } catch (error) {
      console.error('Error al actualizar header y footer:', error);
    }
  }

}
